import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import { cities } from '../data/cities';

const FEATURED = [
  'tacoma', 'seattle', 'lakewood', 'bellevue',
  'puyallup', 'kent', 'renton', 'auburn',
  'federal-way', 'university-place',
  'pierce-county', 'king-county',
];

const ServiceAreasSection = () => {
  return (
    <section className="py-20 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-3">Where I Work</p>
          <h2 className="text-3xl md:text-4xl font-light text-gray-900">
            Serving the Puget Sound Region
          </h2>
          <div className="w-16 h-[1px] bg-gray-300 mx-auto mt-5" />
          <p className="text-base text-gray-600 mt-6 max-w-2xl mx-auto">
            Full-service real estate representation across Pierce and King counties —
            and selected cities in Thurston County.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {FEATURED.map((key) => {
            const c = cities[key];
            if (!c) return null;
            return (
              <Link
                key={key}
                to={`/${c.slug}`}
                className="group flex items-center justify-between px-4 py-3 border border-gray-200 rounded-lg hover:border-gray-900 hover:bg-gray-900 hover:text-white transition-all"
              >
                <span className="flex items-center gap-2 text-sm font-medium">
                  <MapPin size={14} className="text-gray-500 group-hover:text-white" />
                  {c.name}
                </span>
                <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            );
          })}
        </div>

        <p className="text-center text-sm text-gray-500 mt-8">
          Don't see your city?{' '}
          <Link to="/contact" className="underline hover:text-gray-900">
            Get in touch
          </Link>
          {' '}— I cover the entire Puget Sound region.
        </p>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
